
editor2Directive.$inject = ['$uibModal'];
export function editor2Directive($uibModal) {

  return {
    restrict: 'E',
    template: require('./editor2.directive.html'),
    scope: {
      companyId: '=',
      site: '=',
      initialModel: '<?', // This is watched (and will overwrite the editor content if assigned to a different object by the parent scope)
      modelAccessor: '<', // must be set to a variable with a value of {} by the parent; the link() function below will add getter functions to it
      isEmpty: '=?',      // if present, will be updated to reflect whether the text content of all messages are empty
      isTooLong: '=?',    // if present, will be updated to reflect whether the text content of at least one message is currently longer than the configured limit
      isUploading: '=?',    // if present, will be updated to reflect whether a file is currently being uploaded
      options: '=?'       // an object describing which attachment types should be offered, and which language should be used to spell check (if any)
    },
    controller: function() {
      return this;
    },
    link: function link(scope, element, attrs, controller) {
      let $scope = scope;

      $scope.addMessageAfter = addMessageAfter;
      $scope.maybeConfirmAndRremoveMessage = maybeConfirmAndRremoveMessage;

      init();

      // inserts a new message (that is, a codemirror-and-toolbar element) after the given message
      function addMessageAfter(messageEditor) {
        const index = $scope.singleMessageEditors.indexOf(messageEditor);
        $scope.singleMessageEditors.splice(index + 1, 0, {
          'modelAccessor': {},
          'isEmpty': null
        });
      }


      function confirmMessageRemoval() {
        return $uibModal.open({
          animation: true,
          template:  require('../confirmation/confirmation.modal.html'),
          controller: 'ConfirmationController',
          resolve : {
            text : () => 'editor2/confirm-message-removal'
          }
        }).result;
      }


      function maybeConfirmAndRremoveMessage(messageEditor) {
        if (messageEditor.isEmpty) {
          removeMessage(messageEditor);
        } else {
          confirmMessageRemoval().then(() => removeMessage(messageEditor));
        }
      }

      // removes the given message (that is, its codemirror-and-toolbar editor)
      function removeMessage(messageEditor) {
        const index = $scope.singleMessageEditors.indexOf(messageEditor);
        $scope.singleMessageEditors.splice(index, 1);
      }

      // Legacy accessor function, retrocompatible with <editor>
      function modelAccessorGetText() {
        return $scope.singleMessageEditors.map(singleMessageEditor => {
          const model = singleMessageEditor.modelAccessor.getModel();
          const pictures = model.attachments.filter(attachement => attachement.type === 'picture')
                                            .map(attachement => attachement.value.pictureId);
          return {
            'text': model.text,
            'links': model.links,
            'pictures': pictures,
            'attachments': model.attachments,
            'add_switch_to_dm_link': model.addDMLink
          }
        });
      }

      function getModelOfFirstMessage() {
        return $scope.singleMessageEditors[0].modelAccessor.getModel();
      }

      /**
       * There is no two-way data-binding for the editor:
       * the parent scope retreives the content of the editor with one of the functions exposed below.
       * It was working like that in editor1, and although it is not very angularesque,
       * it has the benefit that we don't need to worry about updating some model field 
       * whenever a little something changes in codemirror-and-toolbar.
       */
      function initModelAccessors() {
        $scope.modelAccessor.getText = modelAccessorGetText; // used by tasks.controller
        $scope.modelAccessor.getModelOfFirstMessage = getModelOfFirstMessage; // used by the QR editor
      }

      function areAllEditorsEmpty() {
        return $scope.singleMessageEditors
          .map(editor => editor.isEmpty)
          .reduce((acc, cur) => acc && cur, true);
      }

      function isOneEditorTooLong() {
        return $scope.singleMessageEditors
          .map(editor => editor.isTooLong)
          .reduce((acc, cur) => acc || cur, false);
      }

      function isOneEditorUploading() {
        return $scope.singleMessageEditors
          .map(editor => editor.isUploading)
          .reduce((acc, cur) => acc || cur, false);
      }

      function resetEditors() {
        $scope.singleMessageEditors = [{
          'modelAccessor': {},
          'isEmpty': null,
          'isTooLong': false,
          'isUploading': false,
          'initialModel': $scope.initialModel
        }];
      }

      function initIsEmptyAndIsTooLongUpdates() {
        if ($scope.hasOwnProperty('isEmpty')) {
          $scope.$watch(areAllEditorsEmpty, newVal => $scope.isEmpty = newVal);
        }
        if ($scope.hasOwnProperty('isTooLong')) {
          $scope.$watch(isOneEditorTooLong, newVal => $scope.isTooLong = newVal);
        }
        if ($scope.hasOwnProperty('isUploading')) {
          $scope.$watch(isOneEditorUploading, newVal => $scope.isUploading = newVal);
        }
      }

      function initEditors() {
        if (!$scope.options) {
          // QR editors don't provide options at all at the moment
          $scope.options = {};
        }
        $scope.$watch('initialModel', resetEditors);
      }

      function init() {
        initEditors();
        initModelAccessors();
        initIsEmptyAndIsTooLongUpdates();
      } 
    }
  }
}
